import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { ListManagementScheduleExecutionRequestDto } from '@domain/management-schedule-execution/dtos/list-management-schedule-execution.request.dto';
import { ManagementScheduleExecutionResponseDto } from '@domain/management-schedule-execution/dtos/management-schedule-execution.response.dto';

@Injectable({
  providedIn: 'root',
})
export class ManagementScheduleExecutionService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('management-schedule');
  }

  list(request: ListManagementScheduleExecutionRequestDto) {
    const { managementScheduleRefId, ...params } = request;
    const queryUrl = `${this.getApiUrl()}/${managementScheduleRefId}/execution/list`;
    return this.http.get<
      ApiResponse<PageableResponse<ManagementScheduleExecutionResponseDto>>
    >(queryUrl, { params: { ...params } });
  }
}
